import React from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import Loader from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const SpinnerLoader = (props) => {
    const { promiseInProgress } = usePromiseTracker();

    return (
        promiseInProgress && (
            <div className="loader-wrap">
                <div className="loader">
                    <Loader className="spinner-loader" type="Oval" color="#fff" width={100} height={100} ></Loader>
                    <div className="loading">Loading...</div>
                </div>
            </div >
        )
    )

}

export default SpinnerLoader